/**
 * @generated SignedSource<<09e17d89504e2039f284e3bfda3097bf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Permission = "ADD" | "DEPLOY_POLICIES" | "EDIT" | "EDIT_ACL" | "INFERENCE" | "LOGIN" | "REMOVE" | "VIEW" | "VIEW_ACL" | "VIEW_RESOURCES" | "%future added value";
export type UpdateRoleAssignmentInput = {
  grant?: ReadonlyArray<RoleAssignmentInput> | null | undefined;
  revoke?: ReadonlyArray<RoleAssignmentInput> | null | undefined;
};
export type RoleAssignmentInput = {
  principal: any;
  roleName: string;
  target: any;
};
export type UpdateRoleAssignmentMutation$variables = {
  connections: ReadonlyArray<string>;
  input: UpdateRoleAssignmentInput;
};
export type UpdateRoleAssignmentMutation$data = {
  readonly updateRoleAssignment: {
    readonly grant: ReadonlyArray<{
      readonly errorMessage: string | null | undefined;
      readonly roleAssignment: {
        readonly id: string;
        readonly principal: {
          readonly __typename: string;
          readonly id?: string;
          readonly name?: string;
          readonly roleAssignmentPrincipal: any;
          readonly roleAssignments?: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly role: {
                  readonly id: string;
                  readonly name: string;
                  readonly permissions: ReadonlyArray<Permission>;
                };
                readonly target: {
                  readonly __typename: string;
                  readonly displayName?: string;
                  readonly name?: string;
                  readonly roleAssignmentTarget: any;
                };
              };
            }> | null | undefined;
          };
        };
        readonly role: {
          readonly id: string;
          readonly name: string;
          readonly permissions: ReadonlyArray<Permission>;
        };
        readonly target: {
          readonly __typename: string;
          readonly displayName?: string;
          readonly id?: string;
          readonly name?: string;
          readonly roleAssignmentTarget: any;
        };
      } | null | undefined;
    }> | null | undefined;
    readonly revoke: ReadonlyArray<{
      readonly errorMessage: string | null | undefined;
    }> | null | undefined;
  };
};
export type UpdateRoleAssignmentMutation = {
  response: UpdateRoleAssignmentMutation$data;
  variables: UpdateRoleAssignmentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleAssignmentPrincipal",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v4/*:: as any*/),
    (v7/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissions",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleAssignmentTarget",
  "storageKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    }
  ],
  "type": "RoleScope",
  "abstractKey": null
},
v12 = [
  (v7/*:: as any*/)
],
v13 = {
  "kind": "InlineFragment",
  "selections": (v12/*:: as any*/),
  "type": "AccountGroup",
  "abstractKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": (v12/*:: as any*/),
  "type": "PolicyCollection",
  "abstractKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": (v12/*:: as any*/),
  "type": "RepositoryConfig",
  "abstractKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*:: as any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "target",
  "plural": false,
  "selections": [
    (v5/*:: as any*/),
    (v10/*:: as any*/),
    (v11/*:: as any*/),
    (v13/*:: as any*/),
    (v14/*:: as any*/),
    (v15/*:: as any*/),
    (v16/*:: as any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "RevokeRoleAssignmentPayload",
  "kind": "LinkedField",
  "name": "revoke",
  "plural": true,
  "selections": [
    (v3/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateRoleAssignmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "UpdateRoleAssignmentPayload",
        "kind": "LinkedField",
        "name": "updateRoleAssignment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GrantRoleAssignmentPayload",
            "kind": "LinkedField",
            "name": "grant",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoleAssignment",
                "kind": "LinkedField",
                "name": "roleAssignment",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "principal",
                    "plural": false,
                    "selections": [
                      (v5/*:: as any*/),
                      (v6/*:: as any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*:: as any*/),
                          (v7/*:: as any*/),
                          {
                            "alias": null,
                            "args": (v8/*:: as any*/),
                            "concreteType": "RoleAssignmentConnection",
                            "kind": "LinkedField",
                            "name": "roleAssignments",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RoleAssignmentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoleAssignment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*:: as any*/),
                                      (v9/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "target",
                                        "plural": false,
                                        "selections": [
                                          (v5/*:: as any*/),
                                          (v10/*:: as any*/),
                                          (v11/*:: as any*/),
                                          (v13/*:: as any*/),
                                          (v14/*:: as any*/),
                                          (v15/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "roleAssignments(first:100)"
                          }
                        ],
                        "type": "UserGroup",
                        "abstractKey": null
                      },
                      (v16/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*:: as any*/),
                  (v17/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v18/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "UpdateRoleAssignmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "UpdateRoleAssignmentPayload",
        "kind": "LinkedField",
        "name": "updateRoleAssignment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GrantRoleAssignmentPayload",
            "kind": "LinkedField",
            "name": "grant",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoleAssignment",
                "kind": "LinkedField",
                "name": "roleAssignment",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "principal",
                    "plural": false,
                    "selections": [
                      (v5/*:: as any*/),
                      (v6/*:: as any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*:: as any*/),
                          (v7/*:: as any*/),
                          {
                            "alias": null,
                            "args": (v8/*:: as any*/),
                            "concreteType": "RoleAssignmentConnection",
                            "kind": "LinkedField",
                            "name": "roleAssignments",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RoleAssignmentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoleAssignment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*:: as any*/),
                                      (v9/*:: as any*/),
                                      (v17/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "roleAssignments(first:100)"
                          }
                        ],
                        "type": "UserGroup",
                        "abstractKey": null
                      },
                      (v16/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*:: as any*/),
                  (v17/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "appendNode",
                "key": "",
                "kind": "LinkedHandle",
                "name": "roleAssignment",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  },
                  {
                    "kind": "Literal",
                    "name": "edgeTypeName",
                    "value": "RoleAssignmentEdge"
                  }
                ]
              }
            ],
            "storageKey": null
          },
          (v18/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d0217adb6995791ba706b73558593b6c",
    "id": null,
    "metadata": {},
    "name": "UpdateRoleAssignmentMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateRoleAssignmentMutation(\n  $input: UpdateRoleAssignmentInput!\n) {\n  updateRoleAssignment(input: $input) {\n    grant {\n      errorMessage\n      roleAssignment {\n        id\n        principal {\n          __typename\n          roleAssignmentPrincipal\n          ... on UserGroup {\n            id\n            name\n            roleAssignments(first: 100) {\n              edges {\n                node {\n                  id\n                  role {\n                    id\n                    name\n                    permissions\n                  }\n                  target {\n                    __typename\n                    roleAssignmentTarget\n                    ... on RoleScope {\n                      displayName\n                    }\n                    ... on AccountGroup {\n                      name\n                    }\n                    ... on PolicyCollection {\n                      name\n                    }\n                    ... on RepositoryConfig {\n                      name\n                    }\n                    ... on Node {\n                      __isNode: __typename\n                      id\n                    }\n                  }\n                }\n              }\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        role {\n          id\n          name\n          permissions\n        }\n        target {\n          __typename\n          roleAssignmentTarget\n          ... on RoleScope {\n            displayName\n          }\n          ... on AccountGroup {\n            name\n          }\n          ... on PolicyCollection {\n            name\n          }\n          ... on RepositoryConfig {\n            name\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    revoke {\n      errorMessage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "52e1184fc767e210e94407cfa812abad";

export default node;
